// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__LfOIB","choiceBoxes":"toolbarselects_choiceBoxes__JbfQ7","simpleField":"toolbarselects_simpleField__2GEB6"};